<template>
  <div class="guide-wrap">
    <!-- MOBILE -->
    <div class="m-wrap">
      <!-- Top -->
      <div class="m-top">
        <div class="m-h1">{{ $t('Bet guide') }}</div>
        <div class="m-h2">{{ $t('Placing bet') }}</div>

        <div class="m-steps">
          <div class="m-step">
            <img class="m-step__icon" :src="step1Src" alt="" />
            <div class="m-step__text">{{ $t('Select bet chip') }}</div>
          </div>
          <div class="m-step">
            <img class="m-step__icon" :src="step2Src" alt="" />
            <div class="m-step__text">{{ $t('Place chip by clicking on preferred bet selection') }}</div>
          </div>
          <div class="m-step">
            <img class="m-step__icon" :src="step3Src" alt="" />
            <div class="m-step__text">{{ $t('Click Bet button to confirm your bet') }}</div>
          </div>
        </div>

        <div class="m-betui-wrap">
          <img class="m-betui" :src="betUiSrc" alt="" />
        </div>
      </div>

      <!-- Bottom -->
      <div class="m-bottom">
        <div class="m-h1 m-h1--bottom">{{ $t('Fair game rules') }}</div>

        <div class="m-rules">
          <div class="m-rule">
            <img class="m-rule__icon" :src="fgr1Src" alt="" />
            <div class="m-rule__title">{{ $t('Live streaming') }}</div>
            <div class="m-rule__desc">
              {{ $t('Unforeseen issues such as internet connectivity, power supply, or weather disruptions caused the live stream to be interrupted before the fight began.') }}
              <br /><br />
              {{ $t('If the fight is not displayed on the game site, all bets will be refunded.') }}
            </div>
          </div>

          <div class="m-rule">
            <img class="m-rule__icon" :src="fgr2Src" alt="" />
            <div class="m-rule__title">{{ $t('Arena management decision') }}</div>
            <div class="m-rule__desc">
              {{ $t('Arena management reserves the right to cancel any match; announcements regarding arena decisions will be made on a case-by-case basis.') }}
              <br /><br />
              {{ $t('The match began, but Arena Management determined that cock was injured. Arena management has the right to cancel the fight if neither cock has a cut or bleed. Any other unforeseeable events.') }}
            </div>
          </div>

          <div class="m-rule">
            <img class="m-rule__icon" :src="fgr3Src" alt="" />
            <div class="m-rule__title">{{ $t('Bet not closed in time') }}</div>
            <div class="m-rule__desc">
              {{ $t('Bets placed after the fight began will be void and refunded to members due to unforeseen technical issues.') }}
            </div>
          </div>
        </div>

        <button class="m-tnc" type="button" @click="toggleTNC()">
          {{ $t('Terms & Conditions') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'BetGuide',

  data() {
    return {
      betUiSrc: require('@/assets/images/game-help/betsection.webp'),

      step1Src: require('@/assets/svg/game-help/betguide-1.svg'),
      step2Src: require('@/assets/svg/game-help/betguide-2.svg'),
      step3Src: require('@/assets/svg/game-help/betguide-3.svg'),

      fgr1Src: require('@/assets/svg/game-help/fgr-1.svg'),
      fgr2Src: require('@/assets/svg/game-help/fgr-2.svg'),
      fgr3Src: require('@/assets/svg/game-help/fgr-3.svg'),
    };
  },

  methods: {
    ...mapActions('menu', ['updateMenu']),

    toggleTNC() {
      this.$emit('toggleTnc');
    },
  },
};
</script>

<style lang="scss" scoped>
  .guide-wrap {
    width: 100%;
    box-sizing: border-box;
    color: #fff;
  }

  .m-wrap {
    box-sizing: border-box;
    width: 100%;
    color: #ffffff;
  }

  /* top section */
  .m-top {
    display: grid;
    gap: 10px;
  }

  /* headings match screenshot (smaller) */
  .m-h1 {
    font-weight: 900;
    letter-spacing: 0.06em;
    font-size: 22px;
    text-transform: uppercase;
    color: #ffffff;
  }

  .m-h2 {
    font-weight: 900;
    letter-spacing: 0.1em;
    font-size: 12px;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.85);
  }

  /* steps list */
  .m-steps {
    margin-top: 6px;
    display: grid;
    gap: 10px;
  }

  .m-step {
    display: grid;
    grid-template-columns: 44px 1fr;
    gap: 10px;
    align-items: center;
  }

  .m-step__icon {
    width: 38px !important;
    height: 38px !important;
  }

  .m-step__text {
    font-size: 12px;
    font-weight: 600;
    line-height: 1.25;
    color: rgba(255, 255, 255, 0.92);
  }

  /* bet UI image centered */
  .m-betui-wrap {
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }

  .m-betui {
    width: 100%;
    height: auto;
    border-radius: 14px;
    box-shadow: 0 18px 38px rgba(0, 0, 0, 0.55);
  }

  /* bottom section */
  .m-bottom {
    margin-top: 18px;
    display: grid;
    gap: 12px;
  }

  .m-h1--bottom {
    margin-top: 6px;
  }

  /* rules stacked */
  .m-rules {
    display: grid;
    gap: 16px;
  }

  .m-rule {
    display: grid;
    gap: 10px;
    align-items: start;
  }

  .m-rule__icon {
    width: 34px !important;
    height: 34px !important;
    margin-top: 2px;
  }

  .m-rule__title {
    font-weight: 900;
    letter-spacing: 0.04em;
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 6px;
    color: rgba(255, 255, 255, 0.95);
  }

  .m-rule__desc {
    font-size: 11px;
    font-weight: 600;
    line-height: 1.35;
    color: rgba(255, 255, 255, 0.82);
  }

  /* mobile terms button centered */
  .m-tnc {
    justify-self: start;
    margin-top: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 34px;
    padding: 0 14px;
    border: none;
    border-radius: 8px;
    background: linear-gradient(to bottom, #f4ea9f, #eac35a);
    color: #602b04;
    font-weight: 900;
    font-size: 11px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    cursor: pointer;
    box-shadow: 0 10px 18px rgba(0, 0, 0, 0.35);
  }
</style>